
import moment from 'moment-timezone';


export const dateConverter = (object,key) =>{
    const convertedData = object.map(obj => {
        const dateInUtc = moment(obj[key]).format('DD MMM YYYY');
        // const dateInUtc = moment(obj[key]).format('DD MMM YYYY');
        return { ...obj, [key]: dateInUtc};
      });    
  return convertedData;
}

